/**
 * Configuration for the homepage data source.
 * When enabled, the homepage will fetch courses from the search index (Typesense)
 * instead of the API.
 */
const HOMEPAGE_SEARCH_INDEX_CONFIG = {
  enabled: /true/i.test(
    process.env.NEXT_PUBLIC_HOMEPAGE_USE_SEARCH_INDEX ?? ''
  ),
}

export default HOMEPAGE_SEARCH_INDEX_CONFIG
